import { Link } from 'react-router'
import { Box, Heading, Text, ImageIcon } from '@/components/lib'

export default function ErrorElement () {
  return (
    <Box p={4} borderWidth={4} borderRadius={8} borderColor='border.default' bg='bg.surface' textAlign='center'>
      <Box display='flex' justifyContent='center' alignItems='center' mb={4}>
        <ImageIcon iconKey='wip' size={100} />
      </Box>
      <Heading as='h3' size='md'>Trialflare has encountered an error</Heading>
      <Text>We are sorry, but there was a problem when showing this part of the app.</Text>
      <Text mt={5}>You can try to <Text as={Link} to='/' color='primary.fg'>return to the home page</Text>.</Text>
    </Box>
  )
}
